/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

const CHUNK_RELOAD_PREFIX = "chunk-reload-attempted:";

const isChunkLoadError = (error) => {
  const errorName = error?.name || "";
  const errorMessage = error?.message || "";

  return (
    errorName === "ChunkLoadError" ||
    /Loading chunk [\d]+ failed/i.test(errorMessage) ||
    /Failed to fetch dynamically imported module/i.test(errorMessage) ||
    /Importing a module script failed/i.test(errorMessage)
  );
};

export const lazyWithRetry = (importer, moduleKey) => () =>
  importer()
    .then((module) => {
      if (typeof window !== "undefined") {
        window.sessionStorage.removeItem(`${CHUNK_RELOAD_PREFIX}${moduleKey}`);
      }

      return module;
    })
    .catch((error) => {
      if (typeof window === "undefined" || !isChunkLoadError(error)) {
        throw error;
      }

      const storageKey = `${CHUNK_RELOAD_PREFIX}${moduleKey}`;
      const hasReloaded = window.sessionStorage.getItem(storageKey) === "true";

      if (!hasReloaded && window.navigator.onLine !== false) {
        window.sessionStorage.setItem(storageKey, "true");
        window.location.reload();

        return new Promise(() => {});
      }

      window.sessionStorage.removeItem(storageKey);
      throw error;
    });
